import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'store/store';
import { getClientOrderAction } from 'store/clientPortal/clientOrderSlice';
import { useKeyToSelect } from 'store/createKeyedDataAsyncSlice';
import { RootStore } from 'store/types';
import ClientOrderHeaderApp from './ClientOrderHeaderApp';
import { ErrorMessage } from 'ui-toolkit';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export const ClientOrderHeaderContainer: FCWithChildren = ({ children }) => {
  /* our URL looks something like
        /spa/client/order/:orderId/overview
   */
  const { orderId } = useParams<{ orderId: string }>();
  const dispatch = useAppDispatch();

  const { data, fetchError } = useKeyToSelect(orderId, ({ clientPortal }: RootStore) => clientPortal.clientOrder);

  useEffect(() => {
    dispatch(getClientOrderAction(orderId));
  }, [dispatch, orderId]);

  return (
    <>
      <ErrorMessage error={fetchError} />
      <ClientOrderHeaderApp order={data}>{children}</ClientOrderHeaderApp>
    </>
  );
};
